import React from 'react';
import { Link } from 'react-router-dom';
import { mockWtbRequests } from '../../mockData';
import './Pages.css';

function WtbPage() {
  return (
    <div className="page wtb-page">
      <div className="wtb-header">
        <h1>Want to Buy Requests</h1>
        <p>Browse requests for tech items people want to purchase or post your own request.</p>
        
        <Link to="/create-listing?type=wtb" className="create-wtb-button">
          Post a New WTB Request (HK$15 for 30 days)
        </Link>
      </div>
      
      <div className="wtb-requests-container">
        <h2 className="section-title">Current Requests</h2>
        
        <div className="wtb-requests-grid">
          {mockWtbRequests.map(request => (
            <div key={request.id} className="wtb-request-card">
              <div className="wtb-request-header">
                <h3 className="wtb-request-title">{request.title}</h3>
                <div className="wtb-request-price-range">
                  <span className="price-label">Budget:</span> {request.priceRange}
                </div>
              </div>
              
              <div className="wtb-request-details">
                <p className="wtb-request-description">{request.description}</p>
                <div className="wtb-request-meta">
                  <div className="wtb-request-condition">
                    <span className="meta-label">Desired Condition:</span> {request.desiredCondition}
                  </div>
                  <div className="wtb-request-category">
                    <span className="meta-label">Category:</span> {request.category}
                  </div>
                  <div className="wtb-request-user">
                    <span className="meta-label">Posted by:</span> 
                    <Link to={`/profile/${request.userId}`} className="user-link">
                      {request.username}
                    </Link>
                  </div>
                  <div className="wtb-request-date">
                    <span className="meta-label">Date:</span> {request.postedDate}
                  </div>
                </div>
              </div>
              
              <Link to={`/chat/${request.userId}`} className="contact-user-button">
                Contact User
              </Link>
            </div>
          ))}
        </div>
        
        {mockWtbRequests.length === 0 && (
          <div className="no-results">
            <p>No WTB requests found. Be the first to post a request!</p>
            <Link to="/create-listing?type=wtb" className="create-wtb-button-small">
              Post a WTB Request
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}

export default WtbPage; 